import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'rmt-select-picker',
  templateUrl: 'rmt-select-picker.html'
})
export class RmtSelectPickerComponent {
  @Input() placeholder: string;
  @Input() pickerParams;
  @Input() disable: boolean = false; // unfortunately we can't use the name disabled otherwise we could get reactive form warnings
  @Input() favorites: boolean = false;
  @Input() btnId: string = '';
  @Input() newDesign: boolean = false;
  @Input() label: string;
  @ViewChild('picker') picker;
  @ViewChild('input') input;
  @Output() ionChange = new EventEmitter<string>();
  @Output() searchedText = new EventEmitter<string>();
  /**
   * The error message
  */
     @Input() errorMessage;
     @Input() defaultErrors: boolean = false;
     @Input() refFormControlError;
     @Input() hideError: boolean = false;
     @Input() showOnSubmit: boolean = false;
     @Input() refForm: FormGroup = null;
     @Input() submitAttempts: number = 0;
     @Input() addTopMargin: boolean = false;
     isErrorHidden: boolean = true;
     //#endregion error  

  constructor() {
  }

  ngAfterViewInit() {
    if (this.input.value) {
      const value = this.input.value;
      window.requestAnimationFrame(() => {
        this.picker.setValue(value);
      });
    }
  }

  setValue(value, triggerEvents: boolean = true) {
    this.picker.setValue(value, triggerEvents);
  }

  getValue() {
    return this.picker.getValue();
  }

  select(value) {
    this.input.value = value;
    this.ionChange.emit(value);
  }

  changeInput(ev) {
    if (this.picker.getValue() !== ev.value)
      this.picker.setValue(ev.value);
  }

  onSearchedText(event) {
    this.searchedText.emit(event)
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-select-picker/rmt-select-picker.ts